module.exports = __webpack_public_path__ + "6bef3c248b7b96560591f50549c8a025.svg";